import React, { useEffect, useState } from "react";
/* Components */
import ShaiaBot from "../components/shaiaBot/shaiabot";
import CardList from "../components/card/card-list";
import Button from "../components/button/button";
import { useMediaQuery } from "react-responsive";
import SignUpFormGoogle from "../components/form/signUp_Google";
/* Assets */
import { useMixPanel } from "../hooks/useMixPanel";
import { useTranslation } from "react-i18next";
/* Icons */
import HistoryEmpty from "../assets/icons/history_toggle_off.svg";
import { MIX_PANEL_EVENTS } from "../utils/constans";
import { useMutation } from "react-query";
import { getTeacherSessions } from "../services/teacherSession.service";
import useChatGPTStore from "../store/useChatGPT.store";
import useSessionStore from "../store/useSessionStore";
import useGlobalStore from "../store/useGlobalStore";
import UseCaseHistory from "../components/UseCaseHistory/UseCaseHistory";
import { useNavigate } from "react-router-dom";
import Popup from "../components/popup/popup";
import HubspotForm from "../components/form/hubspotForm";
import useUsageStore from "../store/useUsageStore";
import SignUpFormInst from "../components/form/signUp_Inst";
import { getSuperPowersByTeacher } from "../services/superPower.service";
import FormCourseProfile from "../components/form/formCourseProfile";

const Home = () => {
  const [superPowers, setSuperpowers] = useState([]);
  const { sendEvent } = useMixPanel();
  const { t } = useTranslation();
  const [isView, setIsView] = useState(null);
  const [history, setHistory] = useState([]);
  const [isMenuActive, setIsMenuActive] = useState(false);
  const [isPrinciplesActive, setIsPrinciplesActive] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: 564 });
  const { setClear } = useChatGPTStore();
  const navigate = useNavigate();
  const currentToken = localStorage.getItem("token");
  // const location = useLocation(); 
  const { newUserGoogle, isTeacherOnboarding, user } = useSessionStore();
  const { usageParams } = useUsageStore();
  const { 
    isOpenHistory, 
    setIsOpenHistory, 
    isOpenHistoryH, 
    setIsOpenHistoryH,
    createCourseProfileH,
    setCreateCourseProfileH,
  } = useGlobalStore();

  const teacherSessions = useMutation(getTeacherSessions, {
    onSuccess: (res) => {
      setHistory(res);
    },
    onError: () => {},
  });

  const getSuperpowersByTeacherMutation = useMutation(getSuperPowersByTeacher, {
    onSuccess: (res) => {
      const parsedSuperPowers = res.filter(e => e.show).map((e) => {
        return {
          id: e.slug,
          imgSrc: e.icon,
          link: e.frontend_route,
          useCaseName: e.name,
          hasIconCredit: true,
          creditN: e.credits,
          isNew: e?.is_new,
          tagLabel: !!e?.is_new,
          animate: "",
          translations: e.translations
        };
      });
      setSuperpowers(parsedSuperPowers);
    },
    onError: () => {},
  });

  const getSessionHistoryRoute = (teacherHistory) => {
    switch (teacherHistory?.superPower.slug) {
      case "actividad":
      case "materiales-actividad":
      case "modificar-actividad":
        return `/design-activity?sessionId=${teacherHistory?.session_id}`;
      case "clase":
      case "materiales-clase":
      case "modificar-clase":
        return `/design-class?sessionId=${teacherHistory?.session_id}`;
      case "evaluacion":
      case "modificar-evaluacion":
        case "generar-respuestas":
        return `/design-assess?sessionId=${teacherHistory?.session_id}`;
      case "abp3":
        return `/editing-abp-board?sessionId=${teacherHistory?.session_id}`;
      case "rubrica_1":
      case "modificar-rubrica":
        return `/design-rubric?sessionId=${teacherHistory?.session_id}`;
      case "contexto_real":
      case "modificar-contexto_real":
        return `/design-context?sessionId=${teacherHistory?.session_id}`;
      case "warmup":
      case "modificar-warmup":
        return `/design-startup-dynamic?sessionId=${teacherHistory?.session_id}`;
      default:
        return "/";
    }
  };

  const toggleView = (buttonName, h) => {
    console.log("h ", h);
    setIsView(buttonName);
    const currentRoute = getSessionHistoryRoute(h);
    navigate(currentRoute);
  };

  const toggleClassHistory = () => {
    setIsOpenHistory(!isOpenHistory);
  };

  const toggleClassHistoryH = () => {
    setIsOpenHistoryH(!isOpenHistoryH);
  };

  const toggleCreateCourseProfileH = () => { 
    setCreateCourseProfileH(!createCourseProfileH);
  }

  const toggleClassPrinciples = () => {
    setIsPrinciplesActive(!isPrinciplesActive);
    if (isMenuActive) {
      setIsMenuActive();
    }
  };

  /* Toggle function between components */
  const [toggle, setToggle] = useState(true); // eslint-disable-line

  /*const toggleComponents = useCallback(() => {
    setToggle((toggle) => !toggle);
  }, []);*/

  useEffect(() => {
    return () => {
      setClear();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (currentToken) {
      teacherSessions.mutate();
      sendEvent(MIX_PANEL_EVENTS.home);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentToken]);

  useEffect(() => {
    if (user) {
      getSuperpowersByTeacherMutation.mutate(user.email);
    }
    // eslint-disable-next-line
  }, [user]);

  return (
    <>
      <div className="wrapper-home relative">

      {/* PopUp Creación de perfil de curso */}
        { createCourseProfileH && 
          <div className={`history absolute z-40 w-full h-full rounded-4 bg-DarkBlue-600 overflow-hidden shadow-dark-xl`}>
            <div className="sticky top-0 flex flex-row justify-between items-center p-4 bg-DarkBlue-700">
              <h6 className="blue-text sidebar-title">Perfil de curso</h6>
              <Button
                label="Cerrar"
                variant="primary"
                onClick={toggleCreateCourseProfileH}
                customClassName="py-2 h-6"
              />
            </div>
            <div className="w-full max-h-[90%] h-full relative p-4 overflow-y-auto pb-4">
              <FormCourseProfile />
            </div>
          </div>
        }
        {isOpenHistoryH && (
          <div className={`history absolute z-40 w-full h-full rounded-4 bg-DarkBlue-600 overflow-hidden shadow-dark-xl`}>
            <div className="sticky top-0 flex flex-row justify-between items-center p-4 bg-DarkBlue-700">
              <h6 className="blue-text sidebar-title">{t("historialTitulo")}</h6>
              <Button
                label="Cerrar"
                variant="primary"
                onClick={toggleClassHistoryH}
                customClassName="py-2 h-6"
              />
            </div>
            <div className="w-full max-h-[90%] h-full relative p-4 overflow-y-auto pb-4">
              {history.length ? (
                <>
                  <UseCaseHistory
                    history={history}
                    isView={isView}
                    toggleView={toggleView}
                    showUseCase
                    stringLimit="60"
                  />
                </>
              ) : (
                <>
                  <div className="history_empty">
                    <img src={HistoryEmpty} alt="empty" />
                    <p className="blue-text">{t("historialTituloVacio")}</p>
                  </div>
                </>
              )}
            </div>
          </div>
        )}
        {isMobile && (
          <div className="wrapper_sidebar">
            <div className={`sidebar_history ${ isOpenHistory ? "active" : "" }`}>
              <h6 className="blue-text sidebar-title">{t("historialTitulo")}</h6>
              {history.length ? (
                <>
                  <UseCaseHistory
                    history={history}
                    isView={isView}
                    toggleView={toggleView}
                    showUseCase
                  />
                </>
              ) : (
                <>
                  <div className="history_empty">
                    <img src={HistoryEmpty} alt="empty" />
                    <p className="blue-text">{t("historialTituloVacio")}</p>
                  </div>
                </>
              )}
              <Button
                label="Cerrar"
                variant="primary-outline"
                onClick={toggleClassHistory}
              />
            </div>
          </div>
        )}
        <div
          className={`wrapper_chat-home${
            superPowers.length > 4 ? " wrapper-full" : ""
          }`}
        >
          <div
            className={`chat-content-home${
              superPowers.length > 4 ? " wrapper-full" : ""
            }`}
          >
            <div className="flex flex-row gap-4 items-start justify-start sm-max:items-center sm-max:justify-center sm-max:pt-8">
              {!isMobile && 
                <ShaiaBot />
              }
              <div className="flex flex-col gap-4">
                <div className="title-wrapper">
                  <div className="welcome-text text-Grey-500">
                    {t("homeIntroText1")}
                  </div>
                  <div className="welcome-text text-Grey-500">
                    {t("homeIntroText2")}{" "}
                    <strong>
                      {t("homeIntroText3")}
                      <span className="blue-text">{t("homeIntroText4")}</span>
                    </strong>{" "}
                    {t("homeIntroText5")}
                  </div>
                  <div className="welcome-text font-extrabold text-Grey-500">
                    {t("homeIntroTitle")}
                  </div>
                </div>
              </div>
            </div>
            <div className="chat-content_wrapper">
             {superPowers.length ? <CardList cardsData={superPowers} /> : <div className='text-center mt-4 text-Grey-500 font-bold text-lg' >{t("home_super_poder_cargando")}</div>} 
            </div>
          </div>
        </div>
        {/** Sidebar de principios */}
        <div className="wrapper_sidebar">
          <div
            className={`principles_sidebar ${
              isPrinciplesActive ? "active" : ""
            }`}
          >
            <div className={`principles_sidebar-wrapper ${isMobile && "mb-6"}`}>
              <h5>{t("pricnipiosHomeTitulo")}</h5>
              <p>{t("principiosHomeDescription")}</p>
              <ol>
                <li>{t("principioHomeLabel1")}</li>
                <li>{t("principioHomeLabel2")}</li>
                <li>{t("principioHomeLabel3")}</li>
                <li>{t("principioHomeLabel4")}</li>
                <li>{t("principioHomeLabel5")}</li>
                <li>{t("principioHomeLabel6")}</li>
                <li>{t("principioHomeLabel7")}</li>
                <li>{t("principioHomeLabel8")}</li>
                <li>{t("principioHomeLabel9")}</li>
                <li>{t("principioHomeLabel10")}</li>
                <li>{t("principioHomeLabel11")}</li>
              </ol>
              <Button
                label={t("home_boton_leer_mas")}
                variant="primary"
                onClick={() => navigate("/principles")}
              />
            </div>
            {/*<Button label="Leer más" variant={isMobile ? `primary`: `primary-outline`} />*/}
            {isMobile && (
              <Button
                label={"Cerrar"}
                variant="primary-outline"
                onClick={toggleClassPrinciples}
              />
            )}
          </div>
        </div>
        {/* PopUp bloqueo */}
        {usageParams.total < 1 && (
          <Popup
            isOpen={true}
            customClassName="block-screen md-max:overflow-y-auto"
          >
            <div className="flex md:flex-row md-max:flex-col gap-12 items-center justify-center md-max:justify-start md:max-w-full h-full text-Grey-500 text-left">
              <div className="flex-1 flex flex-col gap-4 max-w-160">
                <h4 className="text-shaiaOrange sm-max:text-4.5">
                  {t("Bloqueo_texto1")}
                </h4>
                <h4 className="text-Grey-500 sm-max:text-4.5">
                  ✨ {t("Bloqueo_texto2")}
                </h4>
                <p className="text-4.5 sm-max:text-4">
                  {t("Bloqueo_texto3")}
                  <br />
                  <br />
                  {t("Bloqueo_texto4")}
                </p>
              </div>
              <div className="hubspot-form flex-1 flex flex-row gap-6">
                <HubspotForm />
              </div>
            </div>
          </Popup>
        )}
      </div>
      {/* PopUp registro google isNew */}
      <Popup isOpen={newUserGoogle}>
        <SignUpFormGoogle />
      </Popup>
      {/* PopUp registro institucional */}
      <Popup isOpen={isTeacherOnboarding}>
        <SignUpFormInst />
      </Popup>
    </>
  );
};

export default Home;
